import React, { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { Loader2, Eye, AlertTriangle } from "lucide-react";

export default function DemoAccessPage() {
  const { token } = useParams();
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .post(`/demo-links/${token}/session`)
      .then(() => api.get("/auth/me"))
      .then((r) => {
        setUser(r.data);
        navigate("/dashboard", { replace: true });
      })
      .catch((e) => setError(formatApiError(e)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="min-h-screen grid place-items-center bg-purple-50 p-4">
      <Card className="w-full max-w-md border-purple-200 shadow-lg">
        <CardContent className="p-8 text-center space-y-4">
          {!error ? (
            <>
              <Loader2 className="h-10 w-10 mx-auto animate-spin text-purple-600" />
              <div className="font-black text-lg" style={{ fontFamily: "Nunito" }} data-testid="demo-loading">
                Abriendo acceso de demostración...
              </div>
              <p className="text-sm text-slate-500 flex items-center justify-center gap-1.5">
                <Eye className="h-4 w-4" /> Modo solo lectura
              </p>
            </>
          ) : (
            <>
              <AlertTriangle className="h-10 w-10 mx-auto text-amber-500" />
              <div className="font-black text-lg" style={{ fontFamily: "Nunito" }} data-testid="demo-error">
                Enlace no válido
              </div>
              <p className="text-sm text-slate-500">{error}</p>
              <Link to="/login" className="inline-block text-sm font-bold text-purple-700 hover:underline" data-testid="demo-go-login">
                Ir al inicio de sesión
              </Link>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
